import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import Logo from "../assets/images/logo.svg";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { NavLink } from "react-router-dom";
import "../styles/HeaderStyles.css";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { authActions } from "../redux/store";
import { refreshPage, delay } from '../functions/utilities/generic';

const Header = () => {

  //state
  const [value, setValue] = useState();

  // global state
  let isLogin = useSelector((state) => state.isLogin);
  isLogin = isLogin || localStorage.getItem("userId");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //logout
  const handleLogout = async () => {
    try {
      dispatch(authActions.logout());
      await delay(500);
      toast.success("Logout Successfully");
      await delay(500);
      navigate("/");
      localStorage.clear();
      localStorage.removeItem('token');
      refreshPage();
    } catch (error) {
      console.log(error);
    }
  };

  const [mobileOpen, setMobileOpen] = useState(false);
  // handle menu click
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  //menu drawer
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography
        color={"goldenrod"}
        variant="h6"
        component="div"
        sx={{ flexGrow: 1, my: 2 }}
      >
        <NavLink to={"/"}>
          <img src={Logo} alt="logo" height={"70"} width="250" />
        </NavLink>
      </Typography>
      <Divider />
      {isLogin && (
        <ul className="mobile-navigation">
          <li>
            <NavLink to={"/blogs"}>Blogs</NavLink>
          </li>
          <li>
            <NavLink to={"/create-blog"}>Create Blog</NavLink>
          </li>
          <li>
            <NavLink to={"/subscribers"}>Subscribers</NavLink>
          </li>
        </ul>
      )}
      {!isLogin && (
        <ul className="mobile-navigation">
          <li>
            <NavLink activeClassName="active" to={"/"}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to={"/about"}>About</NavLink>
          </li>
          <li>
            <NavLink to={"/blogs"}>Blogs</NavLink>
          </li>
          <li>
            <NavLink to={"/contact"}>Contact</NavLink>
          </li>
          {/* <li>
            <NavLink to={"/login"}>
              Login
            </NavLink>
          </li> */}
        </ul>
      )}
      {isLogin && (
        <ul className="mobile-navigation">
          <li>
            <NavLink onClick={handleLogout}>
              Logout
            </NavLink>
          </li>
        </ul>
      )}
    </Box>
  );

  return (
    <>
      <Box>
        <AppBar component={"nav"} sx={{ bgcolor: '#fef7ed' }}>
          <Toolbar>
            <IconButton
              // color="inherit"
              aria-label="open drawer"
              edge="start"
              sx={{
                mr: 2,
                display: { sm: "none" },
              }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              color={"goldenrod"}
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
            >
              <NavLink to={"/"}>
                <img src={Logo} alt="logo" height={"70"} width="250" />
              </NavLink>
            </Typography>

            {isLogin && (
              <Box display={"flex"} marginLeft="auto" marginRight={"auto"}>
                <ul className="navigation-menu">
                  <li>
                    <NavLink to={"/blogs"}>Blogs</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/create-blog"}>Create Blog</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/subscribers"}>Subscribers</NavLink>
                  </li>
                </ul>
              </Box>
            )}
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              {!isLogin && (
                <ul className="navigation-menu">
                  <li>
                    <NavLink activeClassName="active" to={"/"}>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={"/about"}>About</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/blogs"}>Blogs</NavLink>
                  </li>
                  <li>
                    <NavLink to={"/contact"}>Contact</NavLink>
                  </li>
                  {/* <li>
                    <NavLink to={"/login"}>
                      <Box display='flex' alignItems='center'>
                        <AccountCircleIcon />Login
                      </Box>
                    </NavLink>
                  </li> */}
                </ul>
              )}
              {isLogin && (
                <ul>
                  <li>
                    <NavLink onClick={handleLogout}>
                      <Box display='flex' alignItems='center' sx={{ margin: 1, color: "black" }}>
                        <AccountCircleIcon />
                        Logout
                      </Box>
                    </NavLink>
                  </li>
                </ul>
              )}
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "240px",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Box>
          <Toolbar />
        </Box>
      </Box>
    </>
  );
};

export default Header;
